export default "__VITE_ASSET__BhbpOhC2__"